import script from "./CommandPalette.vue?vue&type=script&setup=true&lang=js"
export * from "./CommandPalette.vue?vue&type=script&setup=true&lang=js"

import "./CommandPalette.vue?vue&type=style&index=0&id=c76ab1fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c76ab1fe"]])

export default __exports__